import {
  DialogProps,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material'

type AlertDialogProps = DialogProps & {
  title: string
  message: string
  buttonTexts: {
    cancel: string
    confirm: string
  }
  callbacks: {
    onConfirm: () => void
    onClose: () => void
  }
  destructive?: boolean
  confirmLoading?: boolean
}

export const PopupDialog = ({
  title,
  message,
  buttonTexts,
  callbacks,
  destructive,
  confirmLoading,
  ...dialogProps
}: AlertDialogProps) => {
  const handleCancelClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    callbacks.onClose()
  }
  const handleConfirmClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    callbacks.onConfirm()
  }

  return (
    <Dialog
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
      fullWidth
      onClick={(e) => {
        e.stopPropagation()
        callbacks.onClose()
      }}
      {...dialogProps}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCancelClick}
          variant="outlined"
          color={'primary'}
          size="small"
        >
          {buttonTexts.cancel}
        </Button>
        <Button
          onClick={handleConfirmClick}
          variant="contained"
          size="small"
          color={destructive ? 'error' : 'primary'}
        >
          {confirmLoading ? (
            <CircularProgress
              size={20}
              color="inherit"
              thickness={4}
              sx={{
                display: 'flex',
                padding: '2px',
              }}
            />
          ) : (
            buttonTexts.confirm
          )}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
